<template>
  <div class="income-container">
    <div class="statistics">
      <div class="item">
        <div class="val">{{ storeProfit.storeProfit }}</div>
        <div class="tit">店铺累计收益(元)</div>
      </div>
      <div class="item">
        <div class="val">{{ storeProfit.blockedBalance }}</div>
        <div class="tit">待结算金额(元)</div>
      </div>
      <div class="item">
        <div class="val text-red">{{ storeProfit.withdrawAmount }}</div>
        <div class="tit">可提现金额(元)</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStoreProfit } from "../webApi";
export default {
  data() {
    return {
      storeProfit: {},
    };
  },
  created() {
    getStoreProfit().then(({ data }) => {
      this.storeProfit = data;
    });
  },
};
</script>

<style lang="less" scoped>
.income-container {
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.14);
  border-radius: 16px;
  margin-bottom: 16px;
  .head {
    display: flex;
    justify-content: space-between;
    padding: 20px 18px;
    .tit {
      font-size: 24px;
      line-height: 34px;
      span {
        color: #808080;
        &.active {
          color: #333;
          font-weight: bold;
        }
        & + span {
          margin-left: 20px;
        }
      }
    }
    .read-more {
      font-size: 24px;
      line-height: 34px;
      align-items: center;
      display: flex;
      color: #aeaeae;
      img {
        display: inline-block;
        height: 18px;
        margin-left: 20px;
      }
    }
  }
  .statistics {
    padding: 22px 18px 30px;
    display: flex;
    .item {
      width: 33.33%;
      .val {
        font-size: 32px;
        line-height: 44px;
        font-weight: bold;
      }
      .tit {
        padding-top: 6px;
        font-size: 20px;
        line-height: 28px;
        color: #808080;
      }
    }
  }
}
</style>